import type { RatingSummary } from '../../types';
import { cn } from '../../utils';
import { StarRating } from './StarRating';

interface GlobalRatingProps {
    rating: Pick<RatingSummary, 'average' | 'total'> | null | undefined;
    size?: 'sm' | 'md';
    className?: string;
}

const ratingCountFormatter = new Intl.NumberFormat('es-MX');

export function GlobalRating({
    rating,
    size = 'sm',
    className,
}: GlobalRatingProps) {
    if (!rating || rating.total <= 0 || rating.average === null) {
        return null;
    }

    return (
        <div
            className={cn(
                'inline-flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-1 text-warning',
                size === 'sm' ? 'text-xs' : 'text-sm',
                className,
            )}
            aria-label={`Calificación global: ${rating.average.toFixed(1)} de 5, basada en ${rating.total} ${rating.total === 1 ? 'evaluación' : 'evaluaciones'}`}
        >
            <span className="font-semibold tabular-nums">{rating.average.toFixed(1)}</span>
            <StarRating
                value={rating.average}
                readOnly
                precision={0.1}
                size={size}
                className="shrink-0"
                ariaHidden
            />
            <span className="text-text-muted tabular-nums">
                ({ratingCountFormatter.format(rating.total)})
            </span>
        </div>
    );
}
